export default __webpack_public_path__ + "images/angle-right-faded_564998d3b9c23c5d50234b2773224579.svg";